import BaseClass from './BaseClass'
import axios from '../axios'

export default class LIV_Publications extends BaseClass {
  constructor() {
    super('api/liverpool/publications/')
  }

  async get(id) {
    const res = await axios.get(`${this.urlBase}${id}`)
    return res
  }

  async delete(id) {
    const res = await axios.delete(`${this.urlBase}${id}`)
    return res
  }
}
